module.exports = __webpack_public_path__ + "static/img/image073.265c923.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image073.png
// module id = 9jgl
// module chunks = 1